var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import React, { Component, useState, useEffect, useRef } from "react";
import "tinycolor2";
import $ from "jquery";
import classnames from "classnames";
import Calendar from "react-calendar/dist/entry.nostyle";
import moment from "moment";
import { omit } from "lodash";
import Color from "color";
import AsyncSelect from "@aha-app/react-select/lib/Async";
import AsyncCreatableSelect from "@aha-app/react-select/lib/AsyncCreatable";
import { components } from "@aha-app/react-select";
import SelectroV2, { TemplateResolution, resolveWindowAttachedFunction } from "@aha-app/selectro-v2";
import renderIf from "render-if";
function focusNextElement(direction, overrideFocusedElement) {
  const focusedElement = overrideFocusedElement || document.activeElement;
  if (!focusedElement) {
    return false;
  }
  if (document.querySelectorAll(".react-in-place").length === 0) {
    return false;
  }
  if (focusedElement && focusedElement.classList.contains("react-in-place__input--form")) {
    return false;
  }
  const focussableElements = '.react-in-place__placeholder:not(.react-in-place__selectro),.react-in-place input[type=text]:not([disabled]),.react-in-place input[type=number]:not([disabled]),.note-editor,.aha-editor-field:not(.aha-editor-field-static-content) .aha-editor-body,.custom-field-note-editor,a[tabindex="0"],.aha-sheet,input[type=submit],.react-in-place__input--form,.react-in-place__selectro-v2__container,aha-date-input input[type="text"], aha-date-input button, .attribute__plain-text-value, [data-js-id="script-prompt-position-input"]';
  const focussable = Array.from(
    document.querySelectorAll(focussableElements)
  ).filter((element) => {
    if (element.closest(".react-calendar") || element.closest(".react-in-place__tags__container")) {
      return false;
    }
    if (element.closest(".control-group")) {
      return false;
    }
    return element.offsetWidth > 0 || element.offsetHeight > 0 || element === document.activeElement;
  });
  const index = focussable.indexOf(focusedElement);
  if (index > -1) {
    let nextElement;
    if (direction > 0) {
      nextElement = focussable[index + 1] || focussable[0];
    } else {
      nextElement = focussable[index - 1] || focussable[focussable.length - 1];
    }
    nextElement.focus();
    return true;
  }
  return false;
}
function excludeProps(obj, keys) {
  return Object.keys(obj).filter((i) => !keys.includes(i)).reduce((acc, key) => {
    acc[key] = obj[key];
    return acc;
  }, {});
}
function filterProps(obj, predicate) {
  return Object.keys(obj).filter((i) => i.match(predicate)).reduce((acc, key) => {
    acc[key] = obj[key];
    return acc;
  }, {});
}
function sliceProps(obj, keys) {
  return Object.keys(obj).filter((i) => keys.includes(i)).reduce((acc, key) => {
    acc[key] = obj[key];
    return acc;
  }, {});
}
function isNumber(n) {
  return n != null && !isNaN(parseFloat(n)) && isFinite(n) && typeof n === "number";
}
function parseNumber(input) {
  const cleanNumber = String(input).replace(/[$€¥£,%]/g, "");
  const number = parseFloat(cleanNumber, 10);
  if (!isNumber(number)) {
    return null;
  }
  return number;
}
function validateNumber(input, min, max) {
  let number = parseNumber(input);
  min = (isNumber(min) || !min) && min !== "" ? parseFloat(min, 10) : null;
  max = (isNumber(max) || !max) && max !== "" ? parseFloat(max, 10) : null;
  if (isNumber(max) && max < number) {
    number = max;
  }
  if (isNumber(min) && min > number) {
    number = min;
  }
  return number;
}
function valueOrEmptyString(value, validate = true) {
  if (validate) {
    value = validateNumber(value);
  }
  if (typeof value === "undefined" || value === null) {
    return "";
  } else {
    return value;
  }
}
function formatNumber(value, options) {
  const { nil, delimiter, prefix, suffix } = options;
  if (value === null || value === void 0 || value === "") {
    return nil || " ";
  }
  let middleNumber;
  if (delimiter) {
    middleNumber = value.toLocaleString(void 0, {
      maximumFractionDigits: 14
    });
  } else {
    middleNumber = value;
  }
  return [prefix, middleNumber, suffix].join("").replace(/^\s+|\s+$/g, "");
}
class BaseHandler extends React.Component {
  constructor(props, componentState = {}) {
    super(props);
    __publicField(this, "activate", ({ event, ...componentState }) => {
      if (this.placeholder.current) {
        const rect = this.placeholder.current.getBoundingClientRect();
        const placeholderComputedStyle = window.getComputedStyle(
          this.placeholder.current
        );
        const getComputedStyle = (prop) => parseInt(placeholderComputedStyle.getPropertyValue(prop) || 0, 10);
        const borderLeft = getComputedStyle("border-left-width");
        const borderRight = getComputedStyle("border-right-width");
        const borderTop = getComputedStyle("border-top-width");
        const borderBottom = getComputedStyle("border-bottom-width");
        const verticalBorder = borderTop + borderBottom;
        const horizontalBorder = borderLeft + borderRight;
        const width = rect.width - horizontalBorder - getComputedStyle("padding-left") - getComputedStyle("padding-right");
        const height = rect.height - verticalBorder - getComputedStyle("padding-top") - getComputedStyle("padding-bottom");
        this.setState(
          Object.assign(
            {
              showInput: true,
              focusing: false,
              focused: true,
              originalValue: this.state.value,
              width,
              height
            },
            componentState
          )
        );
      } else {
        this.setState(
          Object.assign(
            {
              showInput: true,
              focusing: false,
              focused: true,
              originalValue: this.state.value
            },
            componentState
          )
        );
      }
      if (this.component.current && this.component.current.activate) {
        this.component.current.activate(event);
      }
    });
    __publicField(this, "abort", () => {
      let newValue = this.state.originalValue;
      if (this.state.reactiveValue) {
        newValue = this.state.reactiveValue;
      }
      this.setState(
        {
          showInput: false,
          value: newValue,
          originalValue: null,
          rawValue: null,
          width: 0,
          height: 0,
          reactiveValue: null,
          skipActivationOnFocus: true
        },
        () => {
          if (this.placeholder.current) {
            this.placeholder.current.focus();
            this.setState({ skipActivationOnFocus: false });
          }
          if (this.props.onClose) {
            this.props.onClose();
          }
        }
      );
    });
    __publicField(this, "deactivate", (refocus = false, componentState = {}) => {
      const state = {
        showInput: false,
        rawValue: null,
        reactiveValue: null,
        originalValue: null
      };
      if (!refocus) {
        state.focused = false;
      }
      let skipOnChange = false;
      let currentValue = typeof componentState.value !== "undefined" ? componentState.value : this.state.value;
      if (currentValue === this.state.originalValue && this.state.reactiveValue) {
        currentValue = this.state.reactiveValue;
        componentState.value = currentValue;
        skipOnChange = true;
      }
      currentValue = this.validate(currentValue);
      this.onValueChange(currentValue);
      if (this.props.onChange && JSON.stringify(currentValue) !== JSON.stringify(this.state.lastValue)) {
        if (!skipOnChange) {
          this.props.onChange(currentValue);
        }
        state.lastValue = currentValue;
      }
      this.setState(
        {
          skipActivationOnFocus: true,
          ...Object.assign(state, componentState)
        },
        () => {
          if (refocus && this.placeholder.current) {
            this.placeholder.current.focus();
            this.setState({ skipActivationOnFocus: false });
            if (!skipOnChange) {
              this.fireChangeEvent();
            }
          }
        }
      );
      if (this.props.onClose) {
        this.props.onClose();
      }
    });
    __publicField(this, "onClear", () => {
      if (this.props.clear) {
        $.ajax({
          url: this.props.clear.path,
          method: this.props.clear.method || "destroy"
        });
      }
      this.deactivate(true, {
        value: null
      });
    });
    __publicField(this, "fireChangeEvent", () => {
      if (this.placeholder && this.placeholder.current) {
        let changeEvent;
        if (typeof Event === "function") {
          changeEvent = new Event("change");
        } else {
          changeEvent = document.createEvent("Event");
          changeEvent.initEvent("change", true, true);
        }
        this.placeholder.current.dispatchEvent(changeEvent);
      }
    });
    __publicField(this, "onValueChange", (newValue, callback) => {
      this.setState({ value: newValue }, callback);
      if (this.props.onValueChange) {
        this.props.onValueChange(newValue);
      }
    });
    __publicField(this, "onInputValueChange", (event) => {
      this.onValueChange(event.target.value);
    });
    __publicField(this, "onInputFocus", (event) => {
      this.setState({ focused: true });
      if (!this.props.formField) {
        event.target.select();
      }
    });
    __publicField(this, "onInputBlur", (event) => {
      if (window.disableReactInPlaceBlur) {
        return;
      }
      this.deactivate();
    });
    __publicField(this, "onKeydown", (event) => {
      switch (event.which) {
        case 32:
          if (!this.state.showInput) {
            this.activate({ event });
            event.preventDefault();
          }
          break;
        case 13:
          if (this.state.showInput) {
            this.deactivate(true);
          } else {
            this.activate({ event });
            event.preventDefault();
          }
          break;
        case 27:
          if (this.state.showInput) {
            this.abort();
          }
          break;
        case 9:
          if (focusNextElement(event.shiftKey ? -1 : 1)) {
            event.preventDefault();
          }
          break;
      }
    });
    __publicField(this, "onPlaceholderClick", (event) => {
      if (event.target.tagName !== "A") {
        this.activate({ event });
      }
    });
    __publicField(this, "onPlaceholderBlur", (event) => {
      if (!document.hasFocus()) {
        this.windowDidBlurIgnoreFocus = true;
      }
      this.setState({ focused: false, focusing: false });
    });
    __publicField(this, "ignoreClick", (event) => {
      event.preventDefault();
      event.stopPropagation();
    });
    this.state = Object.assign(
      {
        showInput: false,
        focused: false,
        value: props.value,
        width: null,
        height: null,
        lastValue: componentState.value || props.value,
        focusing: false,
        reactiveValue: null,
        mouseDown: false
      },
      componentState
    );
    this.component = React.createRef();
    this.placeholder = React.createRef();
  }
  componentDidMount() {
    if (this.props.autofocus) {
      this.activate({});
    }
  }
  componentDidUpdate(prevProps, prevState) {
    if (this.props.value !== prevProps.value && !this.isOpen()) {
      this.onValueChange(this.props.value);
      this.fireChangeEvent();
      this.setState({ lastValue: this.props.value });
    } else if (this.props.value !== prevProps.value) {
      this.setState({ reactiveValue: this.props.value });
    }
  }
  isOpen() {
    return this.state.showInput;
  }
  validate(value) {
    if (this.component.current && this.component.current.validate) {
      value = this.component.current.validate(value);
    }
    return value;
  }
}
function connectDefaultHandler(WrappedComponent) {
  return class DefaultHandler extends BaseHandler {
    render() {
      const ref = WrappedComponent.prototype && WrappedComponent.prototype.render ? this.component : null;
      return /* @__PURE__ */ React.createElement(
        WrappedComponent,
        {
          ...this.props,
          ...this.state,
          ref,
          rawValue: this.props.value,
          placeholder: this.placeholder,
          progressable: this.progressable,
          activate: this.activate,
          onClear: this.onClear,
          abort: this.abort,
          onValueChange: this.onValueChange,
          deactivate: this.deactivate,
          onInputFocus: this.onInputFocus,
          onInputBlur: this.onInputBlur,
          onInputValueChange: this.onInputValueChange,
          onKeyDown: this.onKeydown,
          onPlaceholderClick: this.onPlaceholderClick,
          ignoreClick: this.ignoreClick
        }
      );
    }
  };
}
class CheckboxField extends Component {
  constructor() {
    super(...arguments);
    __publicField(this, "onInputChange", (event) => {
      const value = !this.props.value;
      const state = { value };
      if (this.props.onChange && value !== this.props.lastValue) {
        this.props.onChange(value);
        state.lastValue = value;
      }
      this.props.deactivate(true, state);
    });
    __publicField(this, "onInputClick", (event) => {
      this.onInputChange(event);
      this.props.placeholder.current.focus();
    });
    __publicField(this, "onKeydown", (event) => {
      switch (event.which) {
        case 13:
        // Enter
        case 32:
          this.onInputChange();
          event.preventDefault();
          break;
        case 9:
          focusNextElement(event.shiftKey ? -1 : 1);
          event.preventDefault();
          break;
      }
    });
  }
  render() {
    const baseClasses = this.props.class;
    let valueElement;
    let checkbox;
    if (this.props.value) {
      checkbox = /* @__PURE__ */ React.createElement("i", { className: "fa-regular fa-square-check " });
      if (this.props.inputCheckbox) {
        checkbox = /* @__PURE__ */ React.createElement("input", { type: "checkbox", checked: true, readOnly: true });
      }
      valueElement = /* @__PURE__ */ React.createElement(React.Fragment, null, checkbox, this.props.options[1]);
    } else {
      checkbox = /* @__PURE__ */ React.createElement("i", { className: "fa-regular fa-square" });
      if (this.props.inputCheckbox) {
        checkbox = /* @__PURE__ */ React.createElement("input", { type: "checkbox", checked: false, readOnly: true });
      }
      valueElement = /* @__PURE__ */ React.createElement(React.Fragment, null, checkbox, this.props.options[0]);
    }
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        ref: this.props.placeholder,
        id: this.props.id,
        tabIndex: this.props.tabIndex,
        className: `${baseClasses} ${classnames({
          "react-in-place__placeholder": true
        })}`,
        style: this.props.style,
        onKeyDown: this.props.onKeyDown,
        onClick: this.onInputClick
      },
      valueElement
    );
  }
}
const Checkbox = connectDefaultHandler(CheckboxField);
const CALENDAR_HEIGHT = 256;
const HEADER_HEIGHT = 31;
const CALENDAR_WIDTH = 226;
const FOOTER_HEIGHT = 14;
const FORMAT = "MM-DD-YYYY";
const ALT_FORMAT = "YYYY-MM-DD";
function normalizeDateFormat(dateFormat) {
  dateFormat = dateFormat || FORMAT;
  return dateFormat.replace("%d", "DD").replace("%-d", "D").replace("%-m", "M").replace("%m", "MM").replace("%Y", "YYYY");
}
function convertDate(date, dateFormat) {
  if (!date || date instanceof Date) {
    return date;
  }
  if (!moment.isMoment(date)) {
    date = moment(date, dateFormat);
  }
  return date.toDate();
}
function formatDate(date, format) {
  return moment(date).format(format);
}
function parseDate(str, format) {
  if (str.replace(/[^0-9]/g, "").length < 4 || str.replace(/[^0-9]/g, "") === str && str.length < 5) {
    return false;
  }
  if (str.match(/\d\d\d\d[-/]\d\d?[-/]\d\d?/)) {
    const parsedDate2 = moment(str, ALT_FORMAT);
    if (parsedDate2.isValid() && parsedDate2.isBetween("1900-01-01", "2100-01-01", "year")) {
      return parsedDate2.toDate();
    } else {
      return false;
    }
  }
  if (str.match(/\d\d?[-/]\d\d?[-/]\d\d$/)) {
    const parsedDate2 = moment(str, format.replace("YYYY", "YY"));
    if (parsedDate2.isValid() && parsedDate2.isBetween("1900-01-01", "2100-01-01", "year")) {
      return parsedDate2.toDate();
    }
  }
  const parsedDate = moment(str, format);
  if (!parsedDate.isValid()) {
    return false;
  }
  if (!parsedDate.isBetween("1900-01-01", "2100-01-01", "year")) {
    return false;
  }
  return parsedDate.toDate();
}
class DateField extends Component {
  constructor(props) {
    const dateFormat = normalizeDateFormat(props.dateFormat);
    super(props);
    __publicField(this, "deactivate", (bool, options) => {
      document.removeEventListener("click", this.outsideClickListener);
      this.props.deactivate(bool, options);
    });
    // Calendar doesn't have any input fields
    // so we can close the calendar when the input field blurs
    // in order to tell when the user wants to close the portal without choosing a date.
    __publicField(this, "onInputBlur", (event) => {
      if (window.disableReactInPlaceBlur || this.props.newCalendar) {
        return;
      }
      setTimeout(() => {
        if (!document.activeElement || !document.activeElement.closest(".DayPickerInput")) {
          this.deactivate();
        }
      }, 1);
    });
    __publicField(this, "onInputChange", (event) => {
      const value = event.target.value;
      if (value === "") {
        this.props.onValueChange(null);
        this.setState({ value: null });
      }
      const date = parseDate(value, this.state.dateFormat);
      if (date) {
        this.props.onValueChange(date);
        this.setState({ value: date });
      }
      this.setState({ rawValue: event.target.value });
    });
    __publicField(this, "onAutomaticCheckboxChange", (event) => {
      this.deactivate(true, {
        value: event.target.checked ? "automatic" : "manual"
      });
    });
    __publicField(this, "onClear", (event) => {
      this.props.onClear();
      this.onDayChange(null);
    });
    this.state = {
      dateFormat,
      rawValue: null
    };
    this.onDayChange = this.onDayChange.bind(this);
    this.renderCalendar = this.renderCalendar.bind(this);
    this.handleStencilCalendarRef = this.handleStencilCalendarRef.bind(this);
    this.chooseCalendar = this.chooseCalendar.bind(this);
    this.outsideClickListener = this.outsideClickListener.bind(this);
    this.maybeIgnoreClick = this.maybeIgnoreClick.bind(this);
  }
  normalizedValue() {
    return convertDate(this.props.value, this.state.dateFormat);
  }
  // aha-calendar has input fields, so we must watch for clicks outside of the portal
  // in order to tell when the user wants to close the portal without choosing a date.
  outsideClickListener(event) {
    if (this.props.showInput && !event.target.closest("aha-calendar")) {
      this.deactivate();
    }
  }
  onDayChange(newDay) {
    const newState = {
      value: newDay,
      rawValue: null,
      defaultValue: null
    };
    this.setState(newState);
    this.deactivate(false, { value: newDay });
  }
  validate(newValue) {
    return newValue ? moment(newValue, this.state.dateFormat).toDate() : newValue;
  }
  // calendar buttons should avoid removing focus from the date field input
  maybeIgnoreClick(event) {
    if (this.props.newCalendar) ;
    else {
      this.props.ignoreClick(event);
    }
  }
  handleStencilCalendarRef(ref) {
    if (!ref) {
      return;
    }
    this.calendarElem = ref;
    this.calendarElem.addEventListener("aha-calendar:selected", (event) => {
      if (event.detail) {
        let date = parseDate(event.detail.element.date, ALT_FORMAT);
        this.onDayChange(date);
      }
    });
    setTimeout(() => {
      document.addEventListener("click", this.outsideClickListener);
    }, 0);
  }
  chooseCalendar(calendarType) {
    const value = this.normalizedValue() || this.props.defaultValue || /* @__PURE__ */ new Date();
    if (this.props.newCalendar) {
      const formattedDate = formatDate(value, ALT_FORMAT);
      return /* @__PURE__ */ React.createElement(
        "aha-calendar",
        {
          ref: this.handleStencilCalendarRef,
          date: formattedDate,
          controls: true,
          uniform: true,
          style: {
            margin: "var() var(--spacer-2)",
            padding: "var(--spacer-1)"
          }
        }
      );
    } else {
      return /* @__PURE__ */ React.createElement(
        Calendar,
        {
          minDetail: this.props.minDetail,
          maxDetail: this.props.maxDetail,
          showFixedNumberOfWeeks: true,
          calendarType,
          onChange: this.onDayChange,
          value,
          formatShortWeekday: (value2) => formatDate(value2, "dd"),
          nextLabel: /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-caret-right" }),
          prevLabel: /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-caret-left" }),
          next2Label: null,
          prev2Label: null
        }
      );
    }
  }
  renderCalendar(show, displayClear, displayHeader, value) {
    if (!show) {
      return null;
    }
    const documentRect = window.document.documentElement.getBoundingClientRect();
    const rect = this.props.placeholder.current.getBoundingClientRect();
    let positionClasses = "";
    const computedCalendarHeight = CALENDAR_HEIGHT + (displayHeader ? HEADER_HEIGHT : 0) + FOOTER_HEIGHT;
    const positionStyle = { height: computedCalendarHeight };
    if (rect.bottom + computedCalendarHeight > documentRect.height && rect.top - computedCalendarHeight > 0) {
      positionClasses = "rip-calendar--top";
      positionStyle.top = rect.top - computedCalendarHeight;
    } else {
      positionClasses = "rip-calendar--bottom";
      positionStyle.top = rect.bottom + 4;
    }
    if (rect.left + CALENDAR_WIDTH < documentRect.width) {
      positionClasses += " rip-calendar--left";
      positionStyle.left = rect.left;
    } else {
      positionClasses += " rip-calendar--right";
      positionStyle.left = rect.left - CALENDAR_WIDTH + 40;
    }
    if (this.props.newCalendar) {
      positionStyle.width = "248px";
    }
    let calendarType = "US";
    if (window.currentUser) {
      switch (window.currentUser.startDay) {
        case 1:
          calendarType = "ISO 8601";
          break;
        case 6:
          calendarType = "Arabic";
          break;
        case 0:
          calendarType = "US";
          break;
      }
    }
    let calendarHeader;
    if (this.props.automatic) {
      calendarHeader = /* @__PURE__ */ React.createElement("div", { className: "react-in-place__calendar__header" }, /* @__PURE__ */ React.createElement(
        "input",
        {
          type: "checkbox",
          onChange: this.onAutomaticCheckboxChange,
          defaultChecked: this.props.automatic.set
        }
      ), /* @__PURE__ */ React.createElement("span", null, "Set automatically"), /* @__PURE__ */ React.createElement(
        "i",
        {
          className: "fa-regular fa-question-circle popover-icon",
          "data-content": this.props.automatic.help,
          "data-placement": "left"
        }
      ));
    } else if (displayClear) {
      calendarHeader = /* @__PURE__ */ React.createElement("div", { className: "react-in-place__calendar__header react-in-place__calendar_header--clear" }, /* @__PURE__ */ React.createElement(
        "a",
        {
          className: "react-in-place__calendar_header--clear-link",
          tabIndex: "0",
          onClick: this.onClear
        },
        "Clear date"
      ));
    }
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        className: "react-in-place__calendar-portal",
        onMouseDown: this.maybeIgnoreClick,
        style: positionStyle
      },
      /* @__PURE__ */ React.createElement(
        "div",
        {
          className: `rip-calendar__triangle rip-calendar__triangle--up ${positionClasses}`
        }
      ),
      /* @__PURE__ */ React.createElement("div", { className: "react-in-place__calendar-wrapper" }, calendarHeader, this.chooseCalendar(calendarType)),
      /* @__PURE__ */ React.createElement(
        "div",
        {
          className: `rip-calendar__triangle rip-calendar__triangle--down ${positionClasses}`
        }
      )
    );
  }
  render() {
    const baseClasses = this.props.class;
    let value;
    if (this.props.value === "automatic" || this.props.value === "manual") {
      value = " ";
    } else {
      value = this.normalizedValue() ? moment(this.normalizedValue()).format(this.state.dateFormat) : "";
    }
    const displayClear = this.props.clear && value && value !== "" && value !== " ";
    const displayHeader = this.props.automatic || displayClear;
    const inputValue = this.state.rawValue || this.state.rawValue === "" ? this.state.rawValue : value;
    if (this.props.showInput) {
      return /* @__PURE__ */ React.createElement(
        "div",
        {
          className: `${baseClasses} ${classnames({
            "react-in-place--active": true,
            "react-in-place--empty": !this.normalizedValue()
          })}`,
          ref: this.props.placeholder,
          id: this.props.id,
          style: this.props.style
        },
        /* @__PURE__ */ React.createElement(
          "input",
          {
            className: "react-in-place__input",
            ref: (input) => this.input = input,
            type: "text",
            autoFocus: true,
            tabIndex: this.tabIndex,
            onFocus: this.props.onInputFocus,
            onKeyDown: this.props.onKeyDown,
            onBlur: this.onInputBlur,
            value: inputValue,
            onChange: this.onInputChange,
            style: { width: this.props.width, height: this.props.height }
          }
        ),
        this.renderCalendar(
          !this.props.focusing,
          displayClear,
          displayHeader,
          value
        )
      );
    } else {
      return /* @__PURE__ */ React.createElement(
        "div",
        {
          ref: this.props.placeholder,
          id: this.props.id,
          tabIndex: this.props.tabIndex,
          className: `${baseClasses} ${classnames({
            "react-in-place__placeholder": true,
            "react-in-place__date-input-div": true,
            "react-in-place--allow-selection": this.props.focusing,
            "react-in-place--active": this.props.focusing,
            "react-in-place--empty": !this.normalizedValue()
          })}`,
          style: this.props.style,
          onKeyDown: this.props.onKeyDown,
          onBlur: this.props.onPlaceholderBlur,
          onClick: this.props.onPlaceholderClick,
          "aria-label": this.props.label
        },
        value || this.props.nil || " "
      );
    }
  }
}
const DateInput = connectDefaultHandler(DateField);
const SAVING_DATE_FORMAT$1 = "YYYY-MM-DD";
class DateInputForm extends DateField {
  constructor() {
    super(...arguments);
    __publicField(this, "onDateButtonClick", (event) => {
      if (this.props.placeholder && this.props.placeholder.current) {
        setTimeout(() => {
          this.props.placeholder.current.focus();
        }, 0);
      }
      event.preventDefault();
      return false;
    });
  }
  dateButton() {
    if (!this.props.dateButton) {
      return null;
    }
    return /* @__PURE__ */ React.createElement(
      "button",
      {
        className: classnames("btn", {
          "react-in-place__input-form-date-button--connected": this.props.connectedButton
        }),
        type: "button",
        onClick: this.onDateButtonClick,
        tabIndex: "-1"
      },
      /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-calendar-days" })
    );
  }
  render() {
    const normalizedValue = this.normalizedValue();
    const baseClasses = this.props.class;
    const value = normalizedValue ? moment(normalizedValue).format(this.state.dateFormat) : "";
    const inputValue = this.state.rawValue || this.state.rawValue === "" ? this.state.rawValue : value;
    const saveValue = normalizedValue ? moment(normalizedValue).format(SAVING_DATE_FORMAT$1) : "";
    const dataProps = filterProps(this.props, /data-/);
    return /* @__PURE__ */ React.createElement(React.Fragment, null, this.renderCalendar(this.props.focused, false, false, value), /* @__PURE__ */ React.createElement(
      "input",
      {
        className: `${baseClasses} ${classnames({
          "react-in-place--active": this.props.focused,
          "react-in-place__input": true,
          "react-in-place__input--form": true,
          "react-in-place__input--connected-button": this.props.connectedButton || this.props.dateButton
        })}`,
        ref: this.props.placeholder,
        type: "text",
        tabIndex: this.props.tabIndex,
        autoComplete: "off",
        onFocus: this.props.onInputFocus,
        onKeyDown: this.props.onKeydown,
        onBlur: this.onInputBlur,
        value: inputValue,
        onChange: this.onInputChange,
        style: this.props.style,
        id: this.props.id
      }
    ), /* @__PURE__ */ React.createElement(
      "input",
      {
        type: "hidden",
        name: this.props.fieldName,
        value: saveValue,
        ...dataProps
      }
    ), this.dateButton());
  }
}
const DateInputForm$1 = connectDefaultHandler(DateInputForm);
class DateRangeField extends Component {
  constructor(props) {
    super(props);
    __publicField(this, "normalizedValues", () => {
      return this.props.value ? this.props.value.map((date) => convertDate(date, this.state.dateFormat)) : [null, null];
    });
    __publicField(this, "onStartDateChange", (startDate) => {
      this.updateDate(startDate, true);
    });
    __publicField(this, "onEndDateChange", (endDate) => {
      this.updateDate(endDate, false);
    });
    __publicField(this, "datePickerClosed", (closedStartDate) => {
      const [startDate, endDate] = this.props.value || [];
      const datesAreEmptyOrValid = !startDate || !endDate || startDate <= endDate;
      if (this.dateUpdated && this.dateUpdatedWasStartDate !== closedStartDate && datesAreEmptyOrValid) {
        this.dateUpdated = false;
        this.props.deactivate(false, this.state);
      }
    });
    this.dateUpdated = false;
    this.state = {
      dateFormat: normalizeDateFormat(props.dateFormat)
    };
    this.startDateRef = React.createRef();
    this.endDateRef = React.createRef();
  }
  validate(newValue) {
    if (Array.isArray(newValue)) {
      return [
        convertDate(newValue[0], this.state.dateFormat),
        convertDate(newValue[1], this.state.dateFormat)
      ];
    } else {
      return [null, null];
    }
  }
  updateDate(date, updateStartDate = true) {
    const normalizedValues = this.normalizedValues();
    const value = updateStartDate ? [date, normalizedValues[1]] : [normalizedValues[0], date];
    const updatedIndex = updateStartDate ? 0 : 1;
    const previousDate = normalizedValues[updatedIndex];
    const otherIndex = updateStartDate ? 1 : 0;
    const otherRef = updateStartDate ? this.endDateRef : this.startDateRef;
    const otherDate = value[otherIndex];
    const otherDateIsEmptyOrInvalid = !otherDate || value[0] > value[1];
    if (date && otherDateIsEmptyOrInvalid) {
      const state = {};
      if (otherDate) {
        const duration = moment.duration(
          moment(date).diff(moment(previousDate))
        );
        const days = Math.round(duration.asDays());
        value[otherIndex] = moment(otherDate).add(days, "days").toDate();
      } else {
        state.defaultValue = moment(date)[updateStartDate ? "add" : "subtract"](1, "week").toDate();
      }
      this.props.onValueChange(value);
      if (otherDate) {
        this.dateUpdated = false;
        this.props.deactivate(false, { value });
      } else if (otherRef.current) {
        this.dateUpdated = true;
        this.dateUpdatedWasStartDate = updateStartDate;
        otherRef.current.activate(state);
      }
    } else {
      this.dateUpdated = false;
      this.props.deactivate(false, { value });
    }
  }
  render() {
    const [startNil, endNil] = Array.isArray(this.props.nil) ? this.props.nil : [];
    const normalizedValues = this.normalizedValues();
    const sharedProps = omit(
      this.props,
      "onPlaceholderClick",
      "placeholder",
      "showInput",
      "deactivate",
      "onValueChange"
    );
    return /* @__PURE__ */ React.createElement("div", { className: "react-in-place__date_range_wrapper" }, /* @__PURE__ */ React.createElement(
      DateInput,
      {
        ...sharedProps,
        id: `${this.props.id}__start_date`,
        ref: this.startDateRef,
        key: `${this.props.id}__start_date`,
        clear: this.props.clear && this.props.clear.startDate,
        value: normalizedValues[0],
        nil: startNil,
        onChange: this.onStartDateChange,
        onClose: () => this.datePickerClosed(true),
        label: "Start date"
      }
    ), /* @__PURE__ */ React.createElement("span", { className: "react-in-place__date_range_spacer" }, " — "), /* @__PURE__ */ React.createElement(
      DateInput,
      {
        ...sharedProps,
        id: `${this.props.id}__end_date`,
        ref: this.endDateRef,
        key: `${this.props.id}__end_date`,
        clear: this.props.clear && this.props.clear.endDate,
        value: normalizedValues[1],
        nil: endNil,
        onChange: this.onEndDateChange,
        onClose: () => this.datePickerClosed(false),
        label: "End date"
      }
    ));
  }
}
const DateRangeInput = connectDefaultHandler(DateRangeField);
const NumberArrows = (props) => {
  const { hide, value, height, ignoreClick, min, max } = props;
  const step = props.step || 1;
  if (hide) {
    return null;
  }
  const setValue = (newValue) => {
    const validatedValue = validateNumber(newValue, min, max);
    props.onChange(validatedValue, function() {
      if (props.deactivate) {
        props.deactivate(true);
      }
    });
  };
  const onIncreaseValue = (event) => {
    setValue(parseNumber(value) + step);
    event.preventDefault();
    event.stopPropagation();
    return false;
  };
  const onDecreaseValue = (event) => {
    setValue(parseNumber(value) - step);
    event.preventDefault();
    event.stopPropagation();
    return false;
  };
  const upArrowClasses = classnames({
    "react-in-place__number__up-arrow": true
  });
  const downArrowClasses = classnames({
    "react-in-place__number__down-arrow": true
  });
  return /* @__PURE__ */ React.createElement("div", { className: "react-in-place__number__arrows", style: { height } }, /* @__PURE__ */ React.createElement(
    "a",
    {
      href: "#up-arrow",
      tabIndex: "-1",
      className: upArrowClasses,
      onMouseDown: onIncreaseValue,
      onClick: ignoreClick,
      "aria-label": "Increment"
    },
    /* @__PURE__ */ React.createElement("i", { className: "fa-regular fa-caret-up" })
  ), /* @__PURE__ */ React.createElement(
    "a",
    {
      href: "#down-arrow",
      tabIndex: "-1",
      className: downArrowClasses,
      onMouseDown: onDecreaseValue,
      onClick: ignoreClick,
      "aria-label": "Decrement"
    },
    /* @__PURE__ */ React.createElement("i", { className: "fa-regular fa-caret-down" })
  ));
};
const NumberInput = (props) => {
  let {
    min,
    max,
    width,
    height,
    onFocus,
    autoFocus,
    showPlaceholder,
    inputRef,
    nil,
    step
  } = props;
  min = valueOrEmptyString(min);
  max = valueOrEmptyString(max);
  step = step || 1;
  const [value, setLocalValue] = useState(
    valueOrEmptyString(validateNumber(props.value, props.min, props.max))
  );
  useEffect(() => {
    setLocalValue(
      valueOrEmptyString(validateNumber(props.value, props.min, props.max))
    );
  }, [props.max, props.min, props.value]);
  const setValue = (newValue, validate = true, persist = false) => {
    const validatedValue = validate ? valueOrEmptyString(validateNumber(newValue, props.min, props.max)) : newValue;
    setLocalValue(validatedValue);
    if (persist) {
      props.onChange(validatedValue, function() {
        props.deactivate();
      });
    }
  };
  const onBlur = (event) => {
    setValue(event.target.value, true, true);
  };
  const onChange = (event) => {
    setValue(event.target.value, false, false);
  };
  const onIncreaseValue = (event) => {
    setValue(parseNumber(value) + step);
    event.preventDefault();
    event.stopPropagation();
    return false;
  };
  const onDecreaseValue = (event) => {
    setValue(parseNumber(value) - step);
    event.preventDefault();
    event.stopPropagation();
    return false;
  };
  const onKeyDown = (event) => {
    if (props.noKeyIncrement) {
      props.onKeyDown(event);
    } else {
      switch (event.which) {
        case 13:
          setValue(event.target.value, true, true);
          break;
        case 38:
          onIncreaseValue(event);
          break;
        case 40:
          onDecreaseValue(event);
          break;
        default:
          props.onKeyDown(event);
          break;
      }
    }
  };
  const placeholder = showPlaceholder ? nil : "";
  return /* @__PURE__ */ React.createElement(
    "input",
    {
      ref: inputRef,
      style: {
        width,
        height,
        textAlign: "right"
      },
      type: "text",
      autoFocus,
      className: "react-in-place__input",
      onFocus,
      onBlur,
      onChange,
      onKeyDown,
      value: valueOrEmptyString(value, false),
      step: "any",
      min,
      max,
      placeholder
    }
  );
};
const NumberField = (props) => {
  const value = props.value;
  const width = props.width + 6;
  const baseClasses = props.class;
  const empty = !value && value !== 0;
  const validNumber = valueOrEmptyString(
    validateNumber(props.value, props.min, props.max)
  );
  const numberArrowProps = {
    hide: props.hideArrows,
    height: props.height,
    ignoreClick: props.ignoreClick,
    onChange: props.onValueChange,
    min: props.min,
    max: props.max,
    step: props.step,
    value
  };
  const numberInputProps = {
    min: props.min,
    max: props.max,
    width: props.width - 21,
    height: props.height,
    onFocus: props.onInputFocus,
    onChange: props.onValueChange,
    onKeyDown: props.onKeyDown,
    autoFocus: true,
    showPlaceholder: true,
    inputRef: props.inputRef,
    nil: props.nil,
    deactivate: props.deactivate,
    step: props.step,
    value
  };
  const formatOptions = {
    nil: props.nil,
    delimiter: props.delimiter,
    prefix: props.prefix,
    suffix: props.suffix
  };
  if (props.showInput) {
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        ref: props.placeholder,
        className: `${baseClasses} ${classnames({
          "react-in-place--active": true,
          "react-in-place--empty": empty,
          "react-in-place__progress__input": true
        })}`,
        style: Object.assign({}, props.style, {
          width
        })
      },
      /* @__PURE__ */ React.createElement(NumberArrows, { ...numberArrowProps }),
      /* @__PURE__ */ React.createElement(NumberInput, { ...numberInputProps })
    );
  } else {
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        ref: props.placeholder,
        tabIndex: props.tabIndex,
        className: `${baseClasses} ${classnames({
          "react-in-place__placeholder": true,
          "react-in-place--empty": empty
        })}`,
        style: props.style,
        id: props.id,
        onBlur: props.onPlaceholderBlur,
        onClick: props.onPlaceholderClick,
        onKeyDown: props.onKeyDown,
        suppressHydrationWarning: true
      },
      formatNumber(validNumber, { ...formatOptions })
    );
  }
};
const Number = connectDefaultHandler(NumberField);
const NumberForm = (props) => {
  const value = props.value;
  const baseClasses = props.class;
  const empty = !value && value !== 0;
  const numberArrowProps = {
    hide: props.hideArrows,
    height: props.height,
    ignoreClick: props.ignoreClick,
    onChange: props.onValueChange,
    deactivate: props.deactivate,
    min: props.min,
    max: props.max,
    step: props.step,
    value
  };
  const numberInputProps = {
    min: props.min,
    max: props.max,
    width: null,
    height: props.height,
    onFocus: props.onInputFocus,
    onChange: props.onValueChange,
    onKeyDown: props.onKeyDown,
    autoFocus: false,
    showPlaceholder: true,
    inputRef: props.inputRef,
    nil: props.nil,
    deactivate: props.deactivate,
    step: props.step,
    value
  };
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      ref: props.placeholder,
      className: `${baseClasses} ${classnames({
        "react-in-place--active": props.focused,
        "react-in-place--empty": empty,
        "react-in-place__input--form": true,
        "react-in-place__number": true,
        "react-in-place--no-empty-style": true
      })}`,
      id: props.id,
      style: props.style,
      onClick: props.onPlaceholderClick
    },
    /* @__PURE__ */ React.createElement(NumberArrows, { ...numberArrowProps }),
    /* @__PURE__ */ React.createElement(NumberInput, { ...numberInputProps })
  );
};
const NumberForm$1 = connectDefaultHandler(NumberForm);
const ProgressField = (props) => {
  const [meaningfulChange, setMeaningfulChange] = useState(false);
  const [isMouseDown, setMouseDown] = useState(false);
  const [originalOffset, setOriginalOffset] = useState();
  const [value, setLocalValue] = useState(props.value);
  const progressable = useRef(null);
  useEffect(() => {
    setLocalValue(props.value);
  }, [props.value]);
  const setValue = (newValue) => {
    props.onValueChange(newValue);
  };
  const onMouseDown = (event) => {
    setMouseDown(true);
    setOriginalOffset(event.nativeEvent.offsetX);
    document.addEventListener("mousemove", updatePercentage, false);
    document.addEventListener("mouseup", onMouseUp, false);
    document.body.classList.add("progressable--dragging");
    props.activate({ event });
    updatePercentage(event, true);
    event.preventDefault();
    return false;
  };
  const onMouseUp = (event) => {
    setMouseDown(false);
    document.removeEventListener("mouseup", onMouseUp, false);
    if (!meaningfulChange) {
      onClick(event);
    }
    setMeaningfulChange(false);
    document.body.classList.remove("progressable--dragging");
    event.preventDefault();
    return false;
  };
  const calculateNewPercentage = (event) => {
    if (!progressable.current) {
      return;
    }
    const rects = progressable.current.getClientRects()[0];
    if (!rects) {
      return;
    }
    const { x, width: width2 } = rects;
    const relativePosition = event.pageX - x;
    const upperBoundAdjustedPosition = relativePosition > width2 ? 100 : relativePosition;
    const boundAdjustedPosition = upperBoundAdjustedPosition < 0 ? 0 : upperBoundAdjustedPosition;
    const newPercentage = parseInt(boundAdjustedPosition / width2 * 100, 10);
    return validateNumber(newPercentage, props.min, props.max);
  };
  const updatePercentage = (event, force = false) => {
    event = event.nativeEvent || event;
    if (!isMouseDown && !force) return;
    setMeaningfulChange(Math.abs(originalOffset - event.offsetX) > 5);
    const newPercentage = calculateNewPercentage(event);
    if (meaningfulChange || force) setValue(newPercentage);
  };
  const onClick = (event) => {
    event = event.nativeEvent || event;
    const newPercentage = calculateNewPercentage(event);
    props.onValueChange(newPercentage);
    if (props.numberInput && props.numberInput.current) {
      props.numberInput.current.select();
    } else if (props.placeholder && props.placeholder.current) {
      props.activate({ event });
    }
  };
  const progress = (progressValue) => {
    if (props.disabled) {
      return /* @__PURE__ */ React.createElement("div", { className: "react-in-place__progress__progressable" }, /* @__PURE__ */ React.createElement(
        "div",
        {
          className: "react-in-place__progress__progressable__bar",
          style: { width: `${progressValue || 0}%` }
        }
      ));
    }
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        ref: progressable,
        className: classnames({
          "react-in-place__progress__progressable": true,
          "react-in-place__progress__progressable__bar--dragging": isMouseDown
        }),
        onMouseDown,
        onMouseMove: updatePercentage,
        onMouseUp
      },
      /* @__PURE__ */ React.createElement(
        "div",
        {
          className: "react-in-place__progress__progressable__bar",
          style: { width: `${progressValue || 0}%` }
        }
      )
    );
  };
  const suffix = () => {
    if (props.suffix) {
      return /* @__PURE__ */ React.createElement("span", { className: "react-in-place__progress__suffix" }, props.suffix);
    }
  };
  const baseClasses = props.class || "react-in-place__progress";
  const validNumber = valueOrEmptyString(
    validateNumber(props.value, props.min, props.max)
  );
  let width = props.width;
  if (width < 177) {
    width = 177;
  }
  let numberInputWidth = 13;
  if (value > 9 && value < 100) {
    numberInputWidth = 20;
    width += 7;
  } else if (value > 99) {
    numberInputWidth = 27;
    width += 14;
  }
  const numberInputProps = {
    min: props.min,
    max: props.max,
    width: numberInputWidth,
    height: props.height,
    onFocus: props.onInputFocus,
    onChange: props.onValueChange,
    onKeyDown: props.onKeyDown,
    autoFocus: true,
    showPlaceholder: true,
    inputRef: props.inputRef,
    deactivate: props.deactivate,
    step: props.step,
    value
  };
  const formatOptions = {
    nil: props.nil,
    delimiter: props.delimiter,
    prefix: props.prefix,
    suffix: props.suffix
  };
  const empty = !value && value !== 0;
  if (props.showInput) {
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        ref: props.placeholder,
        className: `${baseClasses} ${classnames({
          "react-in-place--active": true,
          "react-in-place--empty": empty
        })}`,
        style: Object.assign({}, props.style, {
          width
        })
      },
      /* @__PURE__ */ React.createElement("div", { className: "react-in-place__progress__input" }, progress(validNumber), /* @__PURE__ */ React.createElement(NumberInput, { ...numberInputProps }), suffix())
    );
  } else if (value === 0 && !props.disabled) {
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        ref: props.placeholder,
        tabIndex: props.tabIndex,
        className: `${baseClasses} react-in-place__placeholder react-in-place--empty`,
        id: props.id,
        style: { width: 177 },
        onClick: props.onPlaceholderClick,
        onKeyDown: props.onKeyDown
      },
      props.nil || " "
    );
  } else if (props.disabled) {
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        tabIndex: props.tabIndex,
        className: classnames(baseClasses, "react-in-place--disabled"),
        style: props.style,
        id: props.id,
        suppressHydrationWarning: true,
        onKeyDown: props.onKeyDown
      },
      progress(validNumber),
      formatNumber(validNumber, { ...formatOptions })
    );
  } else {
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        ref: props.placeholder,
        tabIndex: props.tabIndex,
        className: `${baseClasses} ${classnames({
          "react-in-place__placeholder": true,
          "react-in-place--empty": empty
        })}`,
        style: props.style,
        id: props.id,
        onBlur: props.onPlaceholderBlur,
        onClick: props.onPlaceholderClick,
        onKeyDown: props.onKeyDown,
        suppressHydrationWarning: true
      },
      progress(validNumber),
      formatNumber(validNumber, { ...formatOptions })
    );
  }
};
const Progress = connectDefaultHandler(ProgressField);
class SelectField extends Component {
  constructor() {
    super(...arguments);
    __publicField(this, "onPlaceholderKeydown", (event) => {
      switch (event.which) {
        case 13:
        // Enter
        case 32:
          this.props.activate({ event });
          event.preventDefault();
          break;
        case 9:
          focusNextElement(event.shiftKey ? -1 : 1);
          event.preventDefault();
          break;
      }
    });
    __publicField(this, "onSelectroKeydown", (key, shiftKey) => {
      switch (key) {
        case 9:
          if (shiftKey) {
            focusNextElement(-1, this.props.placeholder.current);
          } else {
            focusNextElement(1, this.props.placeholder.current);
          }
          break;
        case 27:
          if (this.props.showInput) {
            this.props.deactivate(true);
          }
          break;
      }
    });
  }
  get selectroValue() {
    if (this.props.multiple) {
      return this.props.value.map((v) => [v.label, v.value]);
    } else {
      return [[this.props.value.label, this.props.value.value]];
    }
  }
  generateNewValue(dataArray) {
    const data = dataArray[0];
    const { text, value } = data.option;
    if (data.action === "added") {
      if (this.props.multiple) {
        return this.props.value.concat({ label: text, value });
      } else {
        return { label: text, value };
      }
    } else {
      if (this.props.multiple) {
        return this.props.value.filter((v) => v.value !== value);
      } else {
        return this.props.value;
      }
    }
  }
  emptyValue() {
    if (this.props.multiple) {
      return [];
    } else {
      return { label: null, value: null };
    }
  }
  activate(event) {
    if (this.props.showInput) {
      return false;
    }
    this.isTabbing = false;
    const { selectroValue } = this;
    const props = sliceProps(this.props, [
      "fetch",
      "headers",
      "headersReact",
      "footers",
      "footersReact",
      "multiple",
      "nil",
      "nocache",
      "options",
      "prescript"
    ]);
    if (this.props.clearValueLabel && !this.isEmpty()) {
      if (!props.headersReact) {
        props.headersReact = [];
      }
      props.headersReact.push(
        /* @__PURE__ */ React.createElement(
          "a",
          {
            href: "#",
            onClick: (event2) => {
              this.props.onValueChange(this.emptyValue());
              event2.preventDefault();
            }
          },
          this.props.clearValueLabel
        )
      );
    }
    const options = {
      ...props,
      value: selectroValue,
      headers_clickable: this.props.headersClickable,
      disableTab: true,
      keydownCallback: (event2) => {
        const key = event2.which;
        const shiftKey = event2.shiftKey;
        if (key === 9) {
          this.isTabbing = true;
        }
        this.onSelectroKeydown(key, shiftKey);
        return true;
      },
      selectedCallback: (dataArray) => {
        const newValue = this.generateNewValue(dataArray);
        this.props.onValueChange(newValue);
      },
      clearCallback: () => {
        this.props.onValueChange(this.emptyValue());
      },
      closeCallback: () => {
        setTimeout(() => {
          this.props.deactivate(!this.isTabbing);
          this.isTabbing = false;
        }, 0);
      }
    };
    if (this.props.search) {
      options.show_search = this.props.search;
    }
    window.SelectroHelper.activate(event, options);
  }
  generateStyle() {
    let style = this.props.style;
    if (this.props.options && this.props.options.find) {
      const option = this.props.options && this.props.options.find((option2) => option2[1] === this.props.value.value);
      if (option && option[2] && option[2].color) {
        const darkMode = document.querySelector("body").getAttribute("data-theme") === "dark";
        const color = Color(`#${option[2].color}`);
        const bgColor = darkMode ? new Color("#21282e") : Color("white");
        const background = color.mix(bgColor, 0.6).hex();
        style = Object.assign({}, this.props.style, {
          borderColor: "none",
          backgroundColor: background
        });
      }
    }
    return style;
  }
  isEmpty() {
    if (this.props.multiple) {
      return this.props.value.length === 0;
    } else {
      return this.props.value.value !== "" && !this.props.value.value;
    }
  }
  renderedValue() {
    if (this.props.multiple) {
      return this.isEmpty() ? null : this.props.value.map((v) => v.label).join(", ");
    } else {
      return this.props.value.label;
    }
  }
  render() {
    const baseClasses = this.props.class;
    const { selectroValue } = this;
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        ref: this.props.placeholder,
        tabIndex: this.props.tabIndex,
        className: `${baseClasses} ${classnames({
          "react-in-place__placeholder": true,
          "react-in-place--empty": this.isEmpty(),
          "react-in-place--active": this.props.showInput || this.props.focusing
        })}`,
        style: this.generateStyle(),
        id: this.props.id,
        onMouseDown: this.props.onPlaceholderClick,
        onBlur: this.props.onPlaceholderBlur,
        onKeyDown: this.onPlaceholderKeydown,
        "data-selectrovalue": JSON.stringify(selectroValue)
      },
      this.props.prefixIcon && /* @__PURE__ */ React.createElement(
        "i",
        {
          className: classnames(
            "react-in-place__prefix-icon",
            this.props.prefixIcon
          )
        }
      ),
      /* @__PURE__ */ React.createElement("div", { className: "react-in-place__content" }, this.props.children || this.renderedValue() || this.props.nil || " "),
      this.props.suffixIcon && /* @__PURE__ */ React.createElement(
        "i",
        {
          className: classnames(
            "react-in-place__suffix-icon",
            this.props.suffixIcon
          )
        }
      )
    );
  }
}
const Select = connectDefaultHandler(SelectField);
const MIN_TAG_POPOVER_HEIGHT = 300;
const Option = (props) => {
  return /* @__PURE__ */ React.createElement(components.Option, { ...props, children: /* @__PURE__ */ React.createElement("span", null, props.data.label) });
};
const multiValueLabelInner = (data, labelKey = "label") => {
  let icon;
  if (data.icon) {
    icon = /* @__PURE__ */ React.createElement("i", { className: `fa-solid fa-${data.icon.type}`, style: data.icon.style });
  } else if (data.avatar) {
    icon = /* @__PURE__ */ React.createElement("span", { dangerouslySetInnerHTML: { __html: data.avatar } });
  }
  let label = data[labelKey];
  if (data.link) {
    const linkProps = {
      href: data.link.url
    };
    if (data.link.drawer) {
      linkProps["data-drawer-url"] = data.link.url;
    }
    if (data.link.new_tab) {
      linkProps.target = "_blank";
      linkProps.rel = "noopener noreferrer";
    }
    label = /* @__PURE__ */ React.createElement("a", { ...linkProps }, label);
  }
  const props = {};
  if (data.tooltip) {
    props["data-tooltip"] = data.tooltip;
  }
  return /* @__PURE__ */ React.createElement("span", { ...props }, icon, label);
};
const MultiValueLabel = (props) => {
  return /* @__PURE__ */ React.createElement(
    components.MultiValueLabel,
    {
      ...props,
      children: multiValueLabelInner(props.data)
    }
  );
};
const LoadingMessage = (props) => {
  return /* @__PURE__ */ React.createElement(components.LoadingMessage, { ...props, children: null });
};
const NoOptionsMessage = (props) => {
  return /* @__PURE__ */ React.createElement(components.NoOptionsMessage, { ...props, children: null });
};
const Menu = (props, fieldProps, clickFunc) => {
  const children = [props.children];
  if (fieldProps.headers) {
    const headers = fieldProps.headers.map((header, i) => /* @__PURE__ */ React.createElement(
      "div",
      {
        className: "react-in-place__tags__menu-header",
        key: i,
        onClick: clickFunc,
        dangerouslySetInnerHTML: { __html: header }
      }
    ));
    children.unshift(
      /* @__PURE__ */ React.createElement("div", { className: "react-in-place__tags__menu-headers", key: "headers" }, headers)
    );
  }
  return /* @__PURE__ */ React.createElement(components.Menu, { ...props, children });
};
class TagsField extends Component {
  constructor() {
    super(...arguments);
    __publicField(this, "loadOptions", (inputValue) => {
      inputValue = inputValue || "";
      return new Promise((resolve) => {
        if (this.loadOptionsTimeout) {
          clearTimeout(this.loadOptionsTimeout);
          this.loadOptionsTimeout = null;
        }
        this.optionsCache = this.optionsCache || {};
        if (this.optionsCache[inputValue]) {
          resolve(this.optionsCache[inputValue]);
          return;
        }
        this.loadOptionsTimeout = setTimeout(
          () => {
            $.ajax({
              type: "GET",
              url: this.props.fetch,
              data: {
                q: inputValue,
                in_place: true
              },
              dataType: "json",
              success: (data) => {
                this.optionsCache[inputValue] = data;
                resolve(data);
              }
            });
          },
          inputValue === "" ? 0 : 200
        );
      });
    });
    __publicField(this, "onKeyDown", (event) => {
      switch (event.which) {
        case 27:
          if (this.props.showInput) {
            this.props.deactivate(true);
            event.preventDefault();
            event.stopPropagation();
          }
          break;
        case 13:
          if (event.shiftKey) {
            this.props.deactivate(true);
            event.preventDefault();
            event.stopPropagation();
          } else if (!this.props.showInput) {
            this.props.activate({ event });
          }
          break;
        default:
          this.props.onKeyDown(event);
          break;
      }
    });
    __publicField(this, "onChange", (newValue, action, forceUpdate = false) => {
      if (!this.props.multiple && newValue.length === 0) {
        this.props.onClear();
      } else {
        this.props.onValueChange(newValue, () => {
          if (!this.props.multiple || !this.props.showInput || forceUpdate) {
            this.props.deactivate(true);
          }
        });
      }
    });
    __publicField(this, "onMenuHeaderClick", (event) => {
      this.props.deactivate(true);
    });
    __publicField(this, "removeOption", (event) => {
      const optionToRemove = event.currentTarget.dataset.option;
      const newValue = this.value.filter(
        (option) => option.value !== optionToRemove
      );
      this.onChange(newValue, null, true);
      event.preventDefault();
      event.stopPropagation();
      return false;
    });
  }
  get value() {
    return this.props.value || (this.props.multiple ? [] : null);
  }
  render() {
    var _a;
    const baseClasses = this.props.class;
    const singleTagValue = (_a = this.value) == null ? void 0 : _a.value;
    const empty = this.props.multiple ? this.value.length === 0 : typeof singleTagValue === "undefined" || singleTagValue === null;
    if (this.props.showInput) {
      const rect = this.props.placeholder.current.getBoundingClientRect();
      const bottomDifference = window.innerHeight - rect.bottom;
      let position;
      let popoverHeight;
      const headerHeight = this.props.headers ? this.props.headers.length * 22 : 0;
      if (bottomDifference - headerHeight - 20 > MIN_TAG_POPOVER_HEIGHT) {
        position = "bottom";
        popoverHeight = bottomDifference - headerHeight - 20;
      } else {
        position = "top";
        popoverHeight = rect.top - headerHeight - 20;
      }
      const positionedTop = position === "top";
      let positionedLeft = false;
      if (window.innerWidth < rect.left + 250) {
        positionedLeft = true;
      }
      const TagComponent = this.props.allowCreate ? AsyncCreatableSelect : AsyncSelect;
      return /* @__PURE__ */ React.createElement(
        "div",
        {
          ref: this.props.placeholder,
          key: this.value,
          className: `${baseClasses} ${classnames({
            "react-in-place__placeholder": true,
            "react-in-place--active": true,
            "react-in-place--light-tags": this.props.light,
            "react-in-place--dark-tags": !this.props.light,
            "react-in-place__tags--multiple": this.props.multiple,
            "react-in-place__tags--single": !this.props.multiple,
            "react-in-place--position-top": positionedTop,
            "react-in-place__tags--headers-clickable": this.props.headersClickable
          })}`,
          id: this.props.id,
          style: Object.assign({}, this.props.style, {
            width: this.props.width + 2
          }),
          tabIndex: this.props.tabIndex
        },
        /* @__PURE__ */ React.createElement(
          TagComponent,
          {
            defaultOptions: true,
            cacheOptions: true,
            openMenuOnFocus: true,
            menuIsOpen: true,
            loadOptions: this.loadOptions,
            isMulti: this.props.multiple,
            autoFocus: true,
            allowCreateWhileLoading: true,
            onFocus: this.props.onInputFocus,
            onKeyDown: this.onKeyDown,
            onChange: this.onChange,
            onBlur: this.props.onInputBlur,
            defaultValue: this.value,
            menuPosition: "fixed",
            tabSelectsValueboolean: false,
            menuShouldBlockScroll: true,
            menuPlacement: position,
            maxMenuHeight: popoverHeight,
            headersClickable: this.props.headersClickable,
            className: "react-in-place__tags__container ",
            classNamePrefix: "react-in-place__tags",
            placeholder: "",
            blurInputOnSelect: false,
            closeMenuOnSelect: false,
            styles: {
              container: (base, state) => ({
                ...base,
                width: this.props.width,
                boxShadow: "none",
                textAlign: "left"
              }),
              control: (base, state) => ({
                ...base,
                boxShadow: "none",
                borderRadius: 0,
                background: "none",
                minHeight: "auto",
                height: "100%",
                border: "none"
              }),
              valueContainer: (base, state) => ({
                ...base,
                padding: 0,
                border: "none",
                boxShadow: "none"
              }),
              input: (base, state) => ({
                ...base,
                height: 24,
                lineHeight: "20px",
                margin: "0 2px"
              }),
              multiValue: (base, state) => {
                const baseStyle = {
                  ...base,
                  padding: "3px 6px",
                  borderRadius: "3px"
                };
                if (this.props.light) {
                  baseStyle.backgroundColor = "var(--theme-primary-background)";
                  baseStyle.color = "var(--theme-primary-text)";
                  baseStyle.border = "1px solid var(--theme-secondary-border)";
                } else {
                  baseStyle.color = "var(--theme-inverted-primary-text)";
                  baseStyle.backgroundColor = "var(--theme-inverted-background)";
                  baseStyle.border = "1px solid var(--theme-inverted-background)";
                }
                const styleOverride = state.data.style || {};
                return Object.assign(baseStyle, styleOverride);
              },
              multiValueLabel: (base, state) => ({
                ...base,
                fontSize: "11px",
                lineHeight: "14px",
                padding: 0,
                paddingLeft: 0,
                color: "inherit"
              }),
              multiValueRemove: (base, state) => ({
                ...base,
                padding: 0,
                paddingLeft: 6,
                color: "inherit"
              }),
              menuPortal: (base, state) => {
                const styles = {
                  ...base,
                  zIndex: 950,
                  minWidth: 250
                };
                if (positionedLeft) {
                  styles.left = base.left + this.props.width - 250;
                }
                return styles;
              },
              menu: (base, state) => {
                const extraStyles = {};
                if (this.props.width < 250) {
                  if (positionedTop) {
                    extraStyles.borderBottom = "1px solid rgba(0, 0, 0, 0.2)";
                    if (positionedLeft) {
                      extraStyles.borderBottomLeftRadius = 4;
                    } else {
                      extraStyles.borderBottomRightRadius = 4;
                    }
                  } else {
                    extraStyles.borderTop = "1px solid rgba(0, 0, 0, 0.2)";
                    if (positionedLeft) {
                      extraStyles.borderTopLeftRadius = 4;
                    } else {
                      extraStyles.borderTopRightRadius = 4;
                    }
                  }
                }
                return {
                  ...base,
                  backgroundColor: "var(--theme-input-background)",
                  marginTop: positionedTop ? 3 : 1,
                  marginBottom: positionedTop ? 1 : 3,
                  boxShadow: positionedTop ? "1px -3px 6px 2px rgba(0, 0, 0, 0.2)" : "1px 3px 6px 2px rgba(0, 0, 0, 0.2)",
                  border: "1px solid var(--theme-primary-border)",
                  borderTopLeftRadius: positionedTop ? 4 : 0,
                  borderTopRightRadius: positionedTop ? 4 : 0,
                  borderBottomLeftRadius: positionedTop ? 0 : 4,
                  borderBottomRightRadius: positionedTop ? 0 : 4,
                  borderTopWidth: positionedTop ? 1 : 0,
                  borderBottomWidth: positionedTop ? 0 : 1,
                  width: "calc(100% + 2px)",
                  marginLeft: "-1px",
                  zIndex: 950,
                  textAlign: "left",
                  ...extraStyles
                };
              },
              loadingMessage: (base, state) => ({
                ...base,
                padding: 5,
                textAlign: "left",
                fontSize: "12px",
                color: "var(--theme-primary-text)",
                lineHeight: "16px"
              }),
              noOptionsMessage: (base, state) => ({
                ...base,
                padding: 5,
                textAlign: "left",
                fontSize: "12px",
                color: "var(--theme-primary-text)",
                lineHeight: "16px"
              }),
              menuList: (base, state) => ({
                ...base,
                marginTop: 0,
                paddingTop: 3,
                paddingBottom: 0
              }),
              option: (base, state) => {
                const style = {
                  ...base,
                  backgroundColor: state.isFocused ? "var(--aha-blue-400)" : "transparent",
                  color: state.isFocused ? "var(--theme-inverted-primary-text)" : "var(--theme-primary-text)",
                  cursor: "pointer",
                  padding: "4px 12px"
                };
                if (this.props.headersClickable && state.data.product_line) {
                  style.fontWeight = "bold";
                  style.paddingLeft = 0;
                }
                return style;
              },
              group: (base, state) => ({
                ...base,
                paddingTop: "0",
                paddingBottom: "0"
              }),
              groupHeading: (base, state) => ({
                ...base,
                fontSize: "12px",
                fontWeight: "bold",
                color: "var(--theme-primary-text)",
                textTransform: "none",
                paddingLeft: "0",
                marginTop: "0.25em"
              })
            },
            components: {
              Option,
              MultiValueLabel,
              LoadingMessage,
              NoOptionsMessage,
              Menu: (props) => {
                return Menu(props, this.props, this.onMenuHeaderClick);
              },
              DropdownIndicator: null,
              ClearIndicator: null,
              LoadingIndicator: null
            }
          }
        )
      );
    } else {
      let displayValue;
      if (this.props.multiple && this.value.length > 0) {
        displayValue = this.value.map((option) => /* @__PURE__ */ React.createElement(
          "div",
          {
            className: "react-in-place__tags__multi-value",
            key: option.value,
            style: option.style
          },
          /* @__PURE__ */ React.createElement("div", { className: "react-in-place__tags__multi-value__label" }, multiValueLabelInner(option)),
          /* @__PURE__ */ React.createElement(
            "div",
            {
              className: "react-in-place__tags__multi-value__remove",
              onMouseDown: this.removeOption,
              "data-option": option.value
            },
            /* @__PURE__ */ React.createElement(
              "svg",
              {
                height: "14",
                width: "14",
                viewBox: "0 0 20 20",
                focusable: "false",
                className: "react-in-place__tags__multi-value__remove__x"
              },
              /* @__PURE__ */ React.createElement("path", { d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z" })
            )
          )
        ));
      } else if (!this.props.multiple && this.value) {
        displayValue = /* @__PURE__ */ React.createElement("div", { className: "react-in-place__tags__single-value" }, this.value.label);
      } else {
        displayValue = this.props.nil || " ";
      }
      return /* @__PURE__ */ React.createElement(
        "div",
        {
          ref: this.props.placeholder,
          className: `${baseClasses} ${classnames({
            "react-in-place__placeholder": true,
            "react-in-place--empty": empty,
            "react-in-place--light-tags": this.props.light,
            "react-in-place--dark-tags": !this.props.light,
            "react-in-place__tags--multiple": this.props.multiple,
            "react-in-place__tags--single": !this.props.multiple,
            "react-in-place--will-focus": this.props.focusing
          })}`,
          id: this.props.id,
          style: this.props.style,
          tabIndex: this.props.tabIndex,
          onBlur: this.props.onPlaceholderBlur,
          onClick: this.props.onPlaceholderClick,
          onKeyDown: this.onKeyDown
        },
        displayValue
      );
    }
  }
}
const Tags = connectDefaultHandler(TagsField);
const MIN_AUTOEXPAND_SIZE = 100;
class TextField extends Component {
  constructor(props) {
    super(props);
    __publicField(this, "onInput", (event) => {
      this.height = event.target.scrollHeight;
      return false;
    });
    __publicField(this, "onFocus", (event) => {
      this.height = this.props.height;
      this.props.onInputFocus(event);
    });
    if (this.props.autoExpand) {
      this.fakeSpan = $("<span>").hide().css({ whiteSpace: "pre" }).appendTo(document.body);
    }
    this.inputRef = React.createRef();
    this.height = this.props.height;
  }
  render() {
    const baseClasses = this.props.class;
    const value = this.props.value || "";
    let style = {
      width: this.props.width,
      height: this.height || this.props.height,
      verticalAlign: "top"
    };
    if (this.props.opposite) {
      style = {
        height: this.props.width,
        width: this.height || this.props.height,
        verticalAlign: "top"
      };
    }
    if (this.props.showInput || this.props.formField) {
      if (this.inputRef.current && this.fakeSpan && this.props.autoExpand) {
        const inputStyle = window.getComputedStyle(this.inputRef.current);
        this.fakeSpan.text(value).css({ font: inputStyle.font });
        style.width = Math.max(this.fakeSpan.width(), MIN_AUTOEXPAND_SIZE);
      }
      const inputClasses = classnames(this.props.inputClass, {
        "react-in-place__input": true
      });
      return /* @__PURE__ */ React.createElement(
        "div",
        {
          ref: this.props.placeholder,
          className: `${baseClasses} ${classnames({
            "react-in-place--active": true,
            "react-in-place--empty": !this.props.value
          })}`,
          id: this.props.id,
          style: this.props.style
        },
        /* @__PURE__ */ React.createElement(
          "textarea",
          {
            ref: this.props.inputRef,
            type: "text",
            placeholder: this.props.nil || "",
            autoFocus: true,
            className: inputClasses,
            onFocus: this.onFocus,
            onBlur: this.props.onInputBlur,
            onChange: this.props.onInputValueChange,
            onKeyDown: this.props.onKeyDown,
            maxLength: this.props.maxLength,
            style,
            onInput: this.onInput,
            value
          }
        )
      );
    } else {
      return /* @__PURE__ */ React.createElement(
        "div",
        {
          ref: this.props.placeholder,
          className: `${baseClasses} ${classnames({
            "react-in-place__placeholder": true,
            "react-in-place--empty": !this.props.value,
            [`${this.props.placeholderClass}`]: !this.props.value && this.props.placeholderClass
          })}`,
          id: this.props.id,
          style: this.props.style,
          tabIndex: this.props.tabIndex,
          onClick: this.props.onPlaceholderClick,
          onKeyDown: this.props.onKeyDown,
          onFocus: (e) => {
            !this.props.skipActivationOnFocus && this.props.onPlaceholderClick(e);
          }
        },
        value || this.props.nil || " "
      );
    }
  }
}
const Text = connectDefaultHandler(TextField);
class TextFormField extends Component {
  render() {
    const baseClasses = this.props.class;
    const value = this.props.value || "";
    return /* @__PURE__ */ React.createElement(
      "input",
      {
        type: "text",
        className: `${baseClasses} ${classnames({
          "react-in-place--active": this.props.focused,
          "react-in-place__input": true,
          "react-in-place__input--form": true
        })}`,
        id: this.props.id,
        style: this.props.style,
        onFocus: this.props.onInputFocus,
        onBlur: this.props.onInputBlur,
        onChange: this.props.onInputValueChange,
        onKeyDown: this.props.onKeyDown,
        value
      }
    );
  }
}
const TextForm = connectDefaultHandler(TextFormField);
class MultiSelectField extends SelectField {
  generateStyle() {
    return this.props.style;
  }
  get selectroValue() {
    return this.props.value.map((option) => [option.label, option.value]);
  }
  generateNewValue(dataArray) {
    const newValue = this.props.value.slice();
    dataArray.forEach((item) => {
      if (item.action === "added") {
        newValue.push({ label: item.option.text, value: item.option.value });
      } else {
        const index = newValue.findIndex(
          (option) => option.value === item.option.value
        );
        if (index !== -1) {
          newValue.splice(index, 1);
        }
      }
    });
    return newValue;
  }
  emptyValue() {
    return [];
  }
  isEmpty() {
    return this.props.value.length === 0;
  }
  renderedValue() {
    return this.props.value.map((option) => option.label).join(", ");
  }
}
const MultiSelect = connectDefaultHandler(MultiSelectField);
class SelectForm extends Select {
  render() {
    const baseClasses = this.props.class;
    const selectroValue = [[this.props.value.label, this.props.value.value]];
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        ref: this.placeholder,
        tabIndex: this.props.tabIndex,
        className: `${baseClasses} ${classnames({
          "react-in-place__placeholder": true,
          "react-in-place--empty": this.props.value.value !== "" && !this.props.value.value,
          "react-in-place--active": this.props.showInput || this.props.focusing
        })}`,
        style: this.props.style,
        id: this.props.id,
        onMouseDown: this.onPalaceholderClick,
        onBlur: this.onPlaceholderBlur,
        onKeyDown: this.onPlaceholderKeydown,
        "data-selectrovalue": JSON.stringify(selectroValue)
      },
      /* @__PURE__ */ React.createElement("div", { className: "react-in-place__content" }, this.props.value.label || this.props.nil || " ")
    );
  }
}
class FormField extends Component {
  constructor() {
    super(...arguments);
    __publicField(this, "element", () => {
      const passthroughProps = excludeProps(this.props, [
        "type",
        "object",
        "field",
        "url"
      ]);
      passthroughProps.class = passthroughProps.class || "";
      passthroughProps.class += ` react-in-place__${this.props.type} react-in-place react-in-place--${this.props.inline ? "inline" : "block"}`;
      passthroughProps.class = passthroughProps.class.replace(/^\s+|\s+$/g, "");
      switch (this.props.type) {
        case "number":
          return /* @__PURE__ */ React.createElement(Number, { ...passthroughProps });
        case "progress":
          return /* @__PURE__ */ React.createElement(Progress, { ...passthroughProps });
        case "checkbox":
          return /* @__PURE__ */ React.createElement(Checkbox, { ...passthroughProps });
        case "date":
          return /* @__PURE__ */ React.createElement(DateInputForm$1, { ...passthroughProps });
        case "select":
          return /* @__PURE__ */ React.createElement(SelectForm, { ...passthroughProps });
        default:
          return /* @__PURE__ */ React.createElement(TextForm, { ...passthroughProps });
      }
    });
  }
  render() {
    return /* @__PURE__ */ React.createElement("div", { className: "react-in-place__form" }, this.element());
  }
}
const hasPrependIcon = (cssClass) => /develop-team/.test(cssClass);
class SelectroField extends Component {
  constructor() {
    super(...arguments);
    __publicField(this, "selectroTemplates", () => {
      const { templates, ...props } = this.props;
      return {
        trigger: ({
          items,
          dontUseThisController: controller
        }) => {
          return /* @__PURE__ */ React.createElement(
            "div",
            {
              className: `${props.class} ${classnames({
                "react-in-place__placeholder": true,
                "react-in-place--empty": !items.length,
                "react-in-place--active": props.showInput || props.focusing
              })}`,
              style: this.generateStyle(props, items, controller),
              id: props.id,
              tabIndex: props.tabIndex
            },
            props.prefixIcon && /* @__PURE__ */ React.createElement(
              "i",
              {
                className: classnames(
                  "react-in-place__prefix-icon",
                  props.prefixIcon
                )
              }
            ),
            /* @__PURE__ */ React.createElement("div", { className: "react-in-place__content" }, /* @__PURE__ */ React.createElement(
              TemplateResolution,
              {
                template: templates == null ? void 0 : templates.triggerItems,
                items,
                defaultTemplate: () => items.length ? items.slice(0, 100).map((item) => item.text).join(", ") : controller.state.text.noneSelected
              }
            )),
            props.suffixIcon && /* @__PURE__ */ React.createElement(
              "i",
              {
                className: classnames(
                  "react-in-place__suffix-icon",
                  props.suffixIcon
                )
              }
            )
          );
        },
        itemPrepend: ({
          item,
          dontUseThisController: controller
        }) => {
          return renderIf(
            controller.state.custom.hasIconBeforeItemText && hasPrependIcon(item.data.css_class)
          )(
            /* @__PURE__ */ React.createElement(
              "div",
              {
                className: "SelectroV2__item-prepend",
                style: { minWidth: "20px", textAlign: "left" }
              },
              renderIf(item.data.css_class === "develop-team")(
                /* @__PURE__ */ React.createElement(
                  "i",
                  {
                    className: "fa-regular fa-users",
                    title: "Team",
                    style: { color: "var(--icon-color)" }
                  }
                )
              )
            )
          );
        },
        // Support templates being an object for backwards compatibility
        ...typeof templates === "function" ? templates(this.props) : templates
      };
    });
    __publicField(this, "getSelectedArr", () => {
      const { rawValue } = this.props;
      return (Array.isArray(rawValue) ? rawValue.map(({ value, label, ...otherData }) => ({
        value,
        text: label,
        ...otherData
      })) : [{ value: rawValue == null ? void 0 : rawValue.value, text: rawValue == null ? void 0 : rawValue.label, ...rawValue }]).filter((s) => {
        return !(s.value == null);
      });
    });
    __publicField(this, "toggleDropdown", (target, value) => {
      const selectro_v2_ref = target.querySelector(
        ":scope .SelectroV2__dropdown"
      );
      if (selectro_v2_ref == null ? void 0 : selectro_v2_ref.selectro) {
        selectro_v2_ref.selectro.actionToggleDropdown(value);
      }
    });
    __publicField(this, "handleKeyDown", (e) => {
      switch (e.key) {
        case "Tab":
          if (e.shiftKey) {
            focusNextElement(-1);
          } else {
            focusNextElement(1);
          }
          e.preventDefault();
          break;
        case "Enter":
          this.toggleDropdown(e.currentTarget, true);
          e.preventDefault();
          break;
      }
    });
  }
  setValue(controller, persistChange = false) {
    const selected = controller.selected.map(
      ({ value, text, ...otherData }) => ({
        value,
        label: text,
        ...otherData
      })
    );
    const newValue = controller.isSingleSelect ? selected[0] : selected;
    this.props.onValueChange(newValue);
    if (controller.state.custom.selectAnalyticsCallback) {
      const analyticsCallback = resolveWindowAttachedFunction(
        controller.state.custom.selectAnalyticsCallback,
        "Callbacks"
      );
      if (typeof analyticsCallback === "function") {
        analyticsCallback();
      }
    }
    if (persistChange) {
      this.props.onChange(newValue);
    }
  }
  generateStyle(props, items, state) {
    var _a, _b;
    const value = items[0] && items[0].value;
    const selectedItem = state.items.find((item) => {
      return item.value === value;
    });
    const baseColor = (_a = selectedItem == null ? void 0 : selectedItem.data) == null ? void 0 : _a.color;
    if (!baseColor) {
      return props.style;
    }
    const color = Color(`#${baseColor}`);
    return Object.assign({}, props.style, {
      borderColor: baseColor,
      backgroundColor: ((_b = window == null ? void 0 : window.themeStore) == null ? void 0 : _b.theme) === "dark" ? color.mix(Color("#21282e"), 0.6).hex() : color.mix(Color("white"), 0.6).hex(),
      color: color.mix(Color("black"), 0.6).hex()
    });
  }
  render() {
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        className: "react-in-place__selectro-v2__container",
        ref: this.props.placeholder,
        onKeyDown: this.handleKeyDown,
        tabIndex: this.props.tabIndex
      },
      /* @__PURE__ */ React.createElement(
        SelectroV2,
        {
          disabled: this.props.disabled,
          deferFetch: true,
          type: this.props.selectroType,
          fetchSearchParam: this.props.fetchSearchParam || null,
          usesServerSearch: this.props.usesServerSearch || false,
          branchesSelectable: this.props.branchesSelectable,
          showSelectedList: this.props.showSelectedList,
          includeDataInSelectedItems: this.props.includeDataInSelectedItems || true,
          appendFetchOptionsToExistingParent: this.props.appendFetchOptionsToExistingParent || false,
          ...this.props.cacheFetchResponses !== void 0 && {
            cacheFetchResponses: this.props.cacheFetchResponses
          },
          fetchUrl: this.props.fetch,
          headers: this.props.headers,
          headerVertical: this.props.headerVertical,
          text: this.props.text,
          searchFields: this.props.searchFields || ["text"],
          custom: {
            doNotMatchTriggerHeight: true,
            ...this.props.custom || {}
          },
          items: this.props.options || [],
          selected: this.getSelectedArr(),
          showClearAllButton: typeof this.props.showClearAllButton === "undefined" ? true : this.props.showClearAllButton,
          callbacks: {
            select: ({ controller, payload }) => {
              this.setValue(controller, payload == null ? void 0 : payload.persistChange);
            },
            hidden: () => {
              this.props.deactivate(true);
            },
            clearAll: ({ controller }) => {
              this.setValue(controller);
            },
            afterItemsAdded: ({
              controller
            }) => {
              controller.state.custom.hasIconBeforeItemText = controller.items.some(
                (item) => hasPrependIcon(item.data.css_class)
              );
            },
            ...this.props.callbacks
          },
          templates: this.selectroTemplates(),
          centeredItemContent: this.props.centeredItemContent || false
        }
      )
    );
  }
}
const Selectro = connectDefaultHandler(SelectroField);
const TriggerTemplate = ({ items, controller, internalProps, onChange }) => /* @__PURE__ */ React.createElement(
  "div",
  {
    className: `${internalProps.class} ${classnames({
      "react-in-place__tags": true,
      // Inherit the styles tags are using.
      "react-in-place__placeholder": !internalProps.disabled,
      "react-in-place--disabled": internalProps.disabled,
      "react-in-place--empty": items.length === 0,
      "react-in-place--light-tags": internalProps.light,
      "react-in-place--dark-tags": !internalProps.light,
      "react-in-place--will-focus": internalProps.focusing
    })}`,
    id: internalProps.id,
    style: internalProps.style,
    tabIndex: internalProps.tabIndex,
    onBlur: internalProps.onPlaceholderBlur,
    onClick: internalProps.onPlaceholderClick
  },
  items.length <= 0 && /* @__PURE__ */ React.createElement("div", { className: "react-in-place__content" }, controller.state.text.noneSelected),
  items.map((item) => {
    return /* @__PURE__ */ React.createElement("div", { key: item.value, className: "react-in-place__tags__multi-value" }, /* @__PURE__ */ React.createElement("div", { className: "react-in-place__tags__multi-value__label" }, multiValueLabelInner(item, "text")), /* @__PURE__ */ React.createElement(
      "a",
      {
        className: "react-in-place__tags__multi-value__remove",
        onMouseDown: () => {
          const newValue = items.filter(
            ({ value }) => value !== item.value
          );
          controller.actionSetSelected(newValue);
          onChange(newValue);
        }
      },
      /* @__PURE__ */ React.createElement(
        "svg",
        {
          height: "14",
          width: "14",
          viewBox: "0 0 20 20",
          focusable: "false",
          className: "react-in-place__tags__multi-value__remove__x"
        },
        /* @__PURE__ */ React.createElement("path", { d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z" })
      )
    ));
  })
);
const SelectroTags = React.forwardRef((props, ref) => /* @__PURE__ */ React.createElement(
  Selectro,
  {
    ref,
    ...props,
    templates: (internalProps) => ({
      trigger: ({ items, dontUseThisController: controller }) => /* @__PURE__ */ React.createElement(
        TriggerTemplate,
        {
          ...{ internalProps, items, controller, onChange: props.onChange }
        }
      )
    })
  }
));
class WcDateRangeInput extends React.Component {
  render() {
    return /* @__PURE__ */ React.createElement(DateRangeInput, { ...this.props, newCalendar: true });
  }
}
const SAVING_DATE_FORMAT = "YYYY-MM-DD";
class InplaceField extends Component {
  constructor() {
    super(...arguments);
    __publicField(this, "inputRef", React.createRef());
    __publicField(this, "handleChange", (newValue) => {
      let data = {};
      data[this.props.object] = {};
      let valueToSave = newValue;
      if (this.props.type === "tags" && this.props.multiple) {
        valueToSave = valueToSave.map((option) => option.value);
      } else if (this.props.type === "tags" && valueToSave) {
        valueToSave = valueToSave.value;
      } else if (this.props.type === "select") {
        valueToSave = valueToSave.value;
      } else if (this.props.type === "multi_select") {
        valueToSave = valueToSave.map((option) => option.value);
      } else if (["selectro", "selectro_tags"].includes(this.props.type)) {
        valueToSave = Array.isArray(valueToSave) ? valueToSave.map((option) => option.value) : valueToSave ? valueToSave.value : null;
      } else if (valueToSave instanceof Date) {
        valueToSave = moment(valueToSave).format(SAVING_DATE_FORMAT);
      } else if (this.props.type === "date_range" || this.props.type === "date_range_component") {
        valueToSave = valueToSave.map(
          (date) => date ? moment(date).format(SAVING_DATE_FORMAT) : ""
        );
      }
      if (Array.isArray(valueToSave) && valueToSave.length === 0) {
        valueToSave = [-1];
      }
      if (this.props.allowCreate && this.props.type === "tags" && !this.props.multiple && newValue && newValue.__isNew__) {
        data[this.props.object][this.props.allowCreate] = valueToSave;
        data[this.props.allowCreate] = valueToSave;
      } else if (this.props.allowCreate && this.props.multiple) {
        data[this.props.field] = newValue.filter((option) => !option.__isNew__).map((option) => option.value);
        data[this.props.allowCreate] = newValue.filter((option) => option.__isNew__).map((option) => option.value);
      } else {
        data[this.props.field] = valueToSave;
        data[this.props.object][this.props.field] = valueToSave;
        data[`${this.props.object}${this.props.field}`] = valueToSave;
        if (this.props.automatic && this.props.automatic.property) {
          data[this.props.object][this.props.automatic.property] = valueToSave;
        }
      }
      if (this.props.type === "tags" && !this.props.multiple && newValue === null) {
        return;
      }
      if (this.props.requestData) {
        data = Object.assign({}, data, this.props.requestData);
      }
      const csrfToken = $('meta[name="csrf-token"]').attr("content");
      $.ajax({
        type: this.props.requestType || "PUT",
        headers: { "X-CSRF-Token": csrfToken },
        url: this.props.url,
        dataType: this.props.requestDataType || "json",
        data,
        success: (response) => {
          if (this.props.onSuccess) {
            this.props.onSuccess(response);
          }
        }
      });
    });
  }
  setValue(newValue, refocus = false) {
    if (this.inputRef.current) {
      this.inputRef.current.deactivate(refocus, { value: newValue });
    }
  }
  render() {
    const passthroughProps = excludeProps(this.props, [
      "object",
      "field",
      "url",
      "onSuccess"
    ]);
    passthroughProps.class = passthroughProps.class || "";
    passthroughProps.class += ` react-in-place__${this.props.type} react-in-place react-in-place--${this.props.inline ? "inline" : "block"}`;
    passthroughProps.class = passthroughProps.class.replace(/^\s+|\s+$/g, "");
    switch (this.props.type) {
      case "number":
        return /* @__PURE__ */ React.createElement(
          Number,
          {
            ref: this.inputRef,
            ...passthroughProps,
            onChange: this.handleChange
          }
        );
      case "progress":
        return /* @__PURE__ */ React.createElement(
          Progress,
          {
            ref: this.inputRef,
            ...passthroughProps,
            onChange: this.handleChange
          }
        );
      case "checkbox":
        return /* @__PURE__ */ React.createElement(
          Checkbox,
          {
            ref: this.inputRef,
            ...passthroughProps,
            onChange: this.handleChange
          }
        );
      case "date":
        return /* @__PURE__ */ React.createElement(
          DateInput,
          {
            ref: this.inputRef,
            ...passthroughProps,
            onChange: this.handleChange
          }
        );
      case "date_range":
        return /* @__PURE__ */ React.createElement(
          DateRangeInput,
          {
            ref: this.inputRef,
            ...passthroughProps,
            onChange: this.handleChange
          }
        );
      case "date_range_component":
        return /* @__PURE__ */ React.createElement(
          WcDateRangeInput,
          {
            ref: this.inputRef,
            ...passthroughProps,
            onChange: this.handleChange
          }
        );
      case "select":
        return /* @__PURE__ */ React.createElement(
          Select,
          {
            ref: this.inputRef,
            ...passthroughProps,
            onChange: this.handleChange
          }
        );
      case "multi_select":
        return /* @__PURE__ */ React.createElement(
          MultiSelect,
          {
            ref: this.inputRef,
            ...passthroughProps,
            onChange: this.handleChange
          }
        );
      case "selectro":
        return /* @__PURE__ */ React.createElement(
          Selectro,
          {
            ref: this.inputRef,
            ...passthroughProps,
            onChange: this.handleChange
          }
        );
      case "selectro_tags":
        return /* @__PURE__ */ React.createElement(
          SelectroTags,
          {
            ref: this.inputRef,
            ...passthroughProps,
            onChange: this.handleChange
          }
        );
      case "tags":
        return /* @__PURE__ */ React.createElement(
          Tags,
          {
            ref: this.inputRef,
            ...passthroughProps,
            onChange: this.handleChange
          }
        );
      default:
        return /* @__PURE__ */ React.createElement(
          Text,
          {
            ref: this.inputRef,
            ...passthroughProps,
            onChange: this.handleChange
          }
        );
    }
  }
}
export {
  BaseHandler,
  Checkbox,
  CheckboxField,
  DateField,
  DateInput,
  DateInputForm$1 as DateInputForm,
  DateRangeInput,
  FormField,
  InplaceField,
  MultiSelect,
  Number,
  NumberField,
  NumberForm$1 as NumberForm,
  Progress,
  ProgressField,
  Select,
  SelectField,
  Selectro,
  SelectroField,
  Tags,
  TagsField,
  Text,
  TextField,
  TextForm,
  InplaceField as default,
  focusNextElement
};
